import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  height: 100%;
  width: 100%;
  background-size: cover;
`

export const DropContainer = styled.div`
  display: flex;
  min-height: 60%;
  background: ${colors.background};

  padding: 24px;
  margin: 24px 0;
  border-radius: 12px;
`

export const DropArea = styled.div`
  margin: 0 24px;
`

export const ButtonArea = styled.div`
  float: right;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`
